export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";